import { accountStatusOptions } from '@/venit/services/model/techpubs-enums';

class Validators {
  /* Check if string is valid UUID */
  static checkIfValidUuidOrEmpty(str) {
    if (!str) {
      return true;
    }
    // Regular expression to check if string is a valid UUID
    const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
    return regexExp.test(str);
  }

  static isAccountStatus(str) {
    return accountStatusOptions().indexOf(str) > -1;
  }

}

export default Validators;
